import { useSelector } from 'react-redux';
import { RootState } from '../api/store';
import { User } from '../interfaces/entities/user';
import { UserRoles } from '../enums/userRoles.enum';

export const useAuthenticatedUser = () => {
  const user: User | null = useSelector((state: RootState) => state.auth.user);
  const impersonatedByAdmin: User | null = useSelector((state: RootState) => state.auth.impersonatedByAdmin);

  const isAuthenticated = user !== null;

  const isAdmin = user?.role === UserRoles.admin;
  const isImpersonating = !!impersonatedByAdmin;

  const currentUserIsOwnerOf = (resourceCompanyId: string | undefined | null) => resourceCompanyId && isOwnerOfResource(resourceCompanyId, user);

  return { isAuthenticated, user, isAdmin, currentUserIsOwnerOf, isImpersonating, impersonatedByAdmin };
};

export const isOwnerOfResource = (resourceCompanyId: string, user: User | null) => {
  return user?.role === UserRoles.owner && user.companyId === resourceCompanyId;
};

// // Check if user is the owner of a specific company (not admin)
// export const isCompanyOwner = (companyId: string, user: User | null) =>
//   user?.role === UserRoles.owner && user.companyId === companyId;
